import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SIZES, APPEARANCES, TYPES, HEADING_APPEARANCES, HEADING_TYPES, ALIGN } from './constants';
import Text from '../text';

const Heading = ({
  children,
  type = HEADING_TYPES.heading_1,
  appearance = HEADING_APPEARANCES.default,
  singleLine = false,
  align = ALIGN.left,
}) => {
  const headingClassName = classNames('ws-ui-heading', `ws-ui-heading--${type}`);
  const textAppearance =
    appearance === HEADING_APPEARANCES.default ? APPEARANCES.highEmphasis : appearance;

  return (
    <Text
      type={TYPES.heading}
      size={SIZES.inherit}
      isClipped={singleLine}
      appearance={textAppearance}
      align={align}
      className={headingClassName}
    >
      {children}
    </Text>
  );
};

Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  type: PropTypes.oneOf(Object.values(HEADING_TYPES)),
  appearance: PropTypes.oneOf(Object.values(HEADING_APPEARANCES)),
  singleLine: PropTypes.bool,
  align: PropTypes.oneOf(Object.values(ALIGN)),
};

export default Heading;
